// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3ZEME","actionsCol":"EnrolledClinics_actionsCol__KPc9a"};